export const TOOLTIP_APPEAR_DELAY_MS = 100;
export const TOOLTIP_HIDE_DELAY_MS = 500;
export const EXTRA_LEFT_SHIFT = 6;

export const TOOLTIPS_FOR_STYLES = {
    Casual: 'Простая повседневная одежда, комфорт, джинсы + футболка',
    Classic:
        'Строгие костюмы, "белые воротнички", традиционные фасоны вне времени',
    Minimalism:
        'Лаконичные формы, отсутствие лишних деталей, нейтральные цвета',
    Sport: 'Функциональная одежда для тренировок',
    Streetwear: 'Уличная мода, хайпбист, оверсайз',
    Boho: 'Этнические мотивы, "фестивальный" стиль, свобода, натуральные ткани, бахрома',
    Romantic: 'Женственность, легкие ткани, пастельные тона, рюши',
    OldMoney:
        '"Тихая роскошь", дорогие материалы (кашемир, лен, шелк), сдержанность',
    Grunge: 'Небрежность, клетчатые рубашки, рваные джинсы, растянутые свитера (стиль 90-х)',
    Rock: 'Кожа, косухи, металлические заклепки, черный цвет, дерзость',
    Military: 'Камуфляж, цвет хаки, накладные карманы, грубые ботинки',
    Vintage: 'Аутентичные изделия старше 20 лет (настоящая одежда из прошлого)',
    Retro: 'Современные изделия, стилизованные под прошлые эпохи (новодел в стиле 60-х или 80-х)',
};

export const TOOLTIPS_FOR_CATEGORIES: Record<string, string> = {
    category:
        'Поможет ИИ точно подбирать подходящие комбинации и давать советы, что надеть.',
    style: 'Позволит ИИ рекомендовать образы с учетом Вашего стиля и настроения.',
    occasion:
        'Система учитывает событие, чтобы предлагать подходящие изделия для работы, свидания или путешествия.',

    color: 'ИИ использует цвет, чтобы создавать гармоничные образы и давать рекомендации по сочетаниям.',
    season: 'Позволяет системе подсказывать, что надеть с учетом сезона и погодных условий.',
    material:
        'Система учитывает комфорт и погодные условия при подборе образов.',
};
